/* eslint-disable react/no-unknown-property */
import React from 'react';

export const REASONS = [
  {
    text: 'Driver Call Off',
    value: 'DRIVER_CALL_OFF',
  },
  {
    text: 'Driver Training',
    value: 'DRIVER_TRAINING',
  },
  {
    text: 'Linehaul Delay',
    value: 'LINEHAUL_DELAY',
  },
  {
    text: 'Staff Shortage',
    value: 'STAFF_SHORTAGE',
  },
  {
    text: 'Van Issue',
    value: 'VAN_ISSUE',
  },
  {
    text: 'Other',
    value: 'OTHER',
  },
];

export const COLUMNS = [
  {
    key: 'checkbox',
    dataKey: 'checkbox',
    width: 50,
    cellRenderer: ({ rowData }) => (
      <input
        type="checkbox"
        value={rowData.locationId}
        checked={rowData.checked}
        className="checkbox"
        onChange={() => undefined} // avoid errors about controlled input without onChange
        disabled={
          rowData.jitStatus !== '-' ||
          rowData.stockedTimeUTC !== null ||
          rowData.jit === ''
        }
        uniqueid={rowData.extendedUniqueId}
        locationrouteid={rowData.id}
      />
    ),
  },
  {
    title: 'Region',
    key: 'market',
    dataKey: 'market',
    width: 80,
    sortable: true,
  },
  {
    title: 'Route ID',
    key: 'route',
    dataKey: 'route',
    width: 200,
    sortable: true,
  },
  {
    title: 'Location ID',
    key: 'id',
    dataKey: 'id',
    width: 0,
    flexGrow: 1,
    sortable: true,
  },
  {
    title: 'Stop #',
    key: 'stop',
    dataKey: 'stop',
    width: 60,
    sortable: false,
    align: 'center',
  },
  {
    title: 'JIT Enabled?',
    key: 'jit',
    dataKey: 'jit',
    width: 80,
    sortable: false,
    align: 'center',
  },
  {
    title: 'Change JIT Status',
    key: 'jitStatus',
    dataKey: 'jitStatus',
    width: 110,
    sortable: true,
    cellRenderer: ({ rowData }) => (
      <select
        className="statusDropdown"
        value={
          rowData.jitStatus !== '-'
            ? rowData.jitStatus
            : rowData.jitStatusToUpdate
        }
        disabled={
          rowData.jitStatus !== '-' ||
          rowData.stockedTimeUTC !== null ||
          rowData.jit === '' ||
          rowData.jit === 'N'
        }
        uniqueid={rowData.extendedUniqueId}
        locationrouteid={rowData.id}
        onChange={() => undefined} // avoid errors about controlled input without onChange
      >
        <option value="-" />
        <option value="Off">Off</option>
      </select>
    ),
  },
  {
    title: 'Reason',
    key: 'jitStatusReason',
    dataKey: 'jitStatusReason',
    width: 200,
    cellRenderer: ({ rowData }) => (
      <select
        className={`statusReason ${
          rowData.jitStatusToUpdate === '-' &&
          rowData.jitStatusReason === '' &&
          'hide'
        }`}
        value={rowData.jitStatusReason}
        disabled={rowData.jitStatusToUpdate === '-'}
        uniqueid={rowData.extendedUniqueId}
        locationrouteid={rowData.id}
        onChange={() => undefined} // avoid errors about controlled input without onChange
      >
        {REASONS.map(({ value, text }) => (
          <option value={value} key={value}>
            {text}
          </option>
        ))}
      </select>
    ),
  },
  {
    title: 'Updated By',
    key: 'updatedBy',
    dataKey: 'updatedBy',
    width: 150,
    cellRenderer: ({ rowData }) => (
      <div className="userSubmitted" title={rowData.updatedBy}>
        {rowData.updatedBy}
      </div>
    ),
  },
];
